import { render, staticRenderFns } from "./bulkEmail.vue?vue&type=template&id=2434e0c4&scoped=true&"
import script from "./bulkEmail.vue?vue&type=script&lang=ts&"
export * from "./bulkEmail.vue?vue&type=script&lang=ts&"
import style0 from "./bulkEmail.vue?vue&type=style&index=0&id=2434e0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434e0c4",
  null
  
)

export default component.exports